import defaultValidators from './defaultValidators';

export default Object.keys(defaultValidators).reduce((defaultValidatorNames, validator) => {
  const validatorNames = defaultValidatorNames;
  validatorNames[validator] = validator;
  return validatorNames;
}, {});
